<script setup lang="js">
  import Button from "@/base-components/Button";
  import Lucide from "@/base-components/Lucide";
  import {uri} from "@/constants/config.js";
  import {useFetch} from "@/composables/useFetch.js";
  import domainDialog from "./DomainDialog.vue";
  import OwnerDialog from "./OwnerDialog.vue";
  import { ref } from "vue";

  const domains = defineModel()
  console.log("domains:", domains.value)
  async function changeState(idx) {
    const isActive = !domains.value[idx].isActive
    const {data} = await useFetch(`${uri.admin.cloud.domain.self}/${domains.value[idx].id}`, {body: {isActive}, method: "PATCH"})
    domains.value[idx] = data
  }
  const openDomainDialogeFlag = ref(false)
  const setDomainDialogeFlag = (value) => {
    isEditting.value = false
    openDomainDialogeFlag.value = value
  }
  const onSuccessOpenDomainDialog = () => {
    console.log("onSuccessOpenDomainDialog")
    openDomainDialogeFlag.value = false
    fetchData()
  }
  const fetchData = () => {
    console.log("data fetched from domainView")
  }
  const emit = defineEmits(["registerDomain","addOwner"])
  const registerDomain = (val) => {
    emit("registerDomain", val)
  }
  const isEditting = ref(false)
  const domainDialogRef = ref(null)
  const editDomain = (domain) => {
    isEditting.value = true
    openDomainDialogeFlag.value = true
    domainDialogRef.value?.setDomainData({...domain,isEditting: isEditting.value})
  }

  //Owner dialog
  const ownerDialogRef = ref(null)
  const ownerDialogFlag = ref(false)
  const ownerEditMode = ref(false)
  const setOwnerDialog = (val) => {
    ownerDialogFlag.value = val
    if(!val) ownerDialogRef.value?.clearForm()
  }
  const setOwnerEditMode = (val) =>{
    ownerEditMode.value = val
  }
  const addOwnerClicked = (domain,editMode = false) => {
    setOwnerEditMode(editMode)
    setOwnerDialog(true)
    ownerDialogRef.value?.setFormData(domain)
  }

  import { useRouter } from "vue-router";
  const router = useRouter();
  const ownrClicked = (domain) => {
    if(!domain.Owner) return
    router.push({name:"cloud-users-list",params:{ id:domain.Owner.id }});
    // router.push(`/cloud/user/list?id=${domain.Owner.id}`);
  }
</script>

<template>
  <domainDialog
    v-show="openDomainDialogeFlag"
    @close="setDomainDialogeFlag(false)"
    @onSuccess="onSuccessOpenDomainDialog"
    @registerDomain="registerDomain"
    @fetchData="fetchData"
    :show="openDomainDialogeFlag"
    ref="domainDialogRef"
    :isEditting="isEditting"
  />

  <OwnerDialog
    ref="ownerDialogRef"
    :show="ownerDialogFlag"
    @close="setOwnerDialog(false)"
    @addOwner="emit('addOwner', $event)"
    :editMode="ownerEditMode"
  />

  <div
    class="rounded-lg p-6 space-y-4 border border-gray-200 shadow-sm hover:shadow-md transition-shadow relative bg-white"
  >
    <div class="w-full my-3 flex flex-row pe-6 lg:pe-6 xl:pe-0">
      <h3 class="text-base my-2 font-semibold w-32">Domains</h3>
      <div class="w-full text-end items-end justify-end">
        <Button
          variant="outline-secondary"
          size="sm"
          class="w-36"
          @click="setDomainDialogeFlag(true)"
        >
          <Lucide icon="Plus" class="w-4 h-4 mr-2" />
          {{ $t("button.add-domain") }}
        </Button>
      </div>
    </div>
    <hr />
    <!--Domain Section-->
    <div class="justify-between items-center mt-4">
      <div class="w-full">
        <div class="" v-if="domains && domains.length > 0">
          <div
            class="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-2 xl:grid-cols-4 lg:grid-cols-3 gap-4"
          >
            <div
              class="rounded-lg p-6 space-y-4 border border-gray-200 shadow-sm hover:shadow-md transition-shadow relative box md:mt-2"
              v-for="(domain, idx) in domains"
              :key="domain.id"
              dir="ltr"
            >
              <!-- Header Section -->
              <div class="flex items-center justify-between border-b pb-2 mb-4">
                <div class="w-full flex gap-2">
                  <Lucide
                    icon="Edit"
                    class="h-5 cursor-pointer inline min-w-[20px] text-gray-500"
                    @click="editDomain(domain)"
                  />
                  <h2 class="text-xl font-semibold text-gray-800">
                    {{ domain.displayName }}
                  </h2>
                </div>
                <div class="-mt-3">
                  <div class="text-sm text-gray-500 text-right">
                    {{ domain.name }}
                  </div>
                  <Button
                    :variant="domain.isActive ? 'primary' : 'outline-warning'"
                    size="sm"
                    class="w-16"
                    @click="changeState(idx)"
                  >
                    {{
                      domain.isActive
                        ? $t("title.active")
                        : $t("title.inactive")
                    }}
                  </Button>
                </div>
              </div>

              <!-- Middle Data Fields -->
              <div class="">
                <div class="flex justify-between items-center mb-4">
                  <span class="text-gray-500 text-sm whitespace-nowrap"
                    >Chamber Type</span
                  >
                  <hr class="w-full border-dotted border-gray-400 mx-3" />
                  <span class="font-medium text-gray-800">
                    {{ domain.chamberType }}
                  </span>
                </div>
                <div class="flex mb-4">
                  <div class="w-full flex justify-between items-center">
                    <p class="text-gray-500 text-sm">Reseller</p>
                    <hr class="w-full border-dotted border-gray-400 mx-3" />
                    <Lucide
                      :icon="domain.isReseller === 1 ? 'BadgeCheck' : 'SquareX'"
                      class="w-5 h-5 min-w-5 mr-2 font-bold"
                      :class="{
                        'text-green-500': domain.isReseller === 1,
                        'text-red-500': domain.isReseller === 0,
                      }"
                    />
                  </div>
                </div>
                <div class="flex justify-between items-center mb-4">
                  <span class="text-gray-500 text-sm whitespace-nowrap"
                    >Chamber Type</span
                  >
                  <hr class="w-full border-dotted border-gray-400 mx-3" />
                  <span class="font-medium text-gray-800">
                    {{ domain.chamberType }}
                  </span>
                </div>

                <!-- Entry Points : -->
                <div class="mt-4">
                  <div class="flex flex-col">
                    <span class="text-gray-500 text-sm">Entry Points :</span>
                    <ul class="font-medium text-gray-800 ml-2">
                      <li
                        v-for="entryPoint in domain.config.entryPoints"
                        :key="entryPoint"
                      >
                        {{ entryPoint }}
                      </li>
                    </ul>
                  </div>
                </div>

                <!-- appPage -->
                <div class="text-gray-800 mt-2 flex flex-col">
                  <span class="text-gray-500 text-sm">App Page :</span>
                  <span class="font-medium text-gray-800 ml-2">{{
                    domain.config.homePage
                  }}</span>
                </div>

                <!-- homePage -->
                <div class="text-gray-800 mt-2 flex flex-col">
                  <span class="text-gray-500 text-sm">Home Page :</span>
                  <span class="font-medium text-gray-800 ml-2">{{
                    domain.config.appPage
                  }}</span>
                </div>

                <!-- owner -->
                <div class="gap-4 border-b my-3"></div>
                <div
                  class="w-full flex justify-between items-center mb-2"
                  :class="domain.Owner ? 'cursor-pointer' : ''"
                  @click="ownrClicked(domain)"
                >
                  <p class="text-gray-500 text-sm">Owner</p>
                  <hr class="w-full border-dotted border-gray-400 mx-3" />
                  <p class="font-medium text-gray-800 whitespace-nowrap">
                    {{
                      domain.Owner ? domain.Owner.email : $t("title.noOwner")
                    }}
                  </p>
                </div>
                <div v-if="!domain.Owner">
                  <Button
                    variant="success"
                    size="sm"
                    class="p-2 w-[100%]"
                    @click="addOwnerClicked(domain, false)"
                  >
                    <Lucide icon="Plus" class="inline mr-2" />
                    {{ $t("title.addOwner") }}
                  </Button>
                </div>
                <!-- FIXME: if edit ioener was added remove hidden and add edit api and data -->
                <div class="hidden" v-else>
                  <Button
                    variant="success"
                    size="sm"
                    class="p-2 w-[100%]"
                    @click="addOwnerClicked(domain, true)"
                  >
                    <Lucide icon="Edit" class="inline mr-2" />
                    {{ $t("title.editOwner") }}
                  </Button>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div v-else>Empty</div>
      </div>
    </div>
  </div>
</template>

<style scoped></style>
